import { useState, useImperativeHandle, forwardRef, useRef, React, useEffect } from 'react';
import styled from 'styled-components';

import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

import { ReactComponent as SearchSvg } from '../../image/Searching.svg';

const SearchInput = forwardRef((props, ref) => {
	const { value, setValue, className, placeholder, type, clickCountFn } = props;
	const [changed, setChanged] = useState(false);
	const [changedPlaceholderColor, setChangedPlaceholderColor] = useState(false);
	const [clickCount, setClickCount] = useState(0);
	const [defaultPlaceholder, setDefaultPlaceholder] = useState(placeholder);

	const { isDark } = useTheme();
	const theme = isDark ? darkTheme : lightTheme;

	const inputRef = useRef();

	useEffect(() => {
		setDefaultPlaceholder(placeholder);
	}, [placeholder]);

	useImperativeHandle(ref, () => ({
		setValue: (val) => {
			setValue(val);
			setChanged(true);
		},
		getValue: () => {
			if (changed)
				return value;
			else
				return "";
		},
		plusClickCount: () => {
			setClickCount(clickCount + 1)
		},
		getClickCount: () => {
			return clickCount;
		},
		setDefaultPlaceholder: (val) => {
			setDefaultPlaceholder(val)
			setChangedPlaceholderColor(true);
			inputRef.current.style.borderColor = theme.pointRed;
		},
		reset: (val) => {
			setClickCount(0);
			setDefaultPlaceholder(val)
			inputRef.current.style.borderColor = theme.line;
		}
	}));

	function handleClick(e) {
		inputRef.current.style.borderColor = theme.primary;
	}

	function handleChange(e) {
		setValue(e.target.value);
		setChanged(true);
	}

	function handleFocus(e) {
		setChangedPlaceholderColor(false);
		if (changed) {
			// do nothing
		} else {
			setValue("");
		}
	}

	function handleBlur(e) {
		setClickCount(clickCount + 1);
		inputRef.current.style.borderColor = theme.line;
	}

	return (
		<InputWrapper>
			<SearchIcon />
			<Input
				ref={inputRef}
				clickCount={clickCount}
				type={type}
				placeholder={defaultPlaceholder}
				value={value}
				changedColor={changedPlaceholderColor}
				className={`${className} ${changed ? "changed" : ""}`}
				onClick={handleClick}
				onChange={handleChange}
				onFocus={handleFocus}
				onBlur={handleBlur} />
		</InputWrapper>
	);
});

export default SearchInput;

const InputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const SearchIcon = styled(SearchSvg)`
  position: absolute;
  left: 10px;

  width: 20px;
  height: 20px;

  pointer-events: none;

  & path {
    fill: ${props => props.theme.line};
  }
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 12px;
	line-height: 20px;

  padding: 0 0 0 40px;

  box-sizing: border-box;
  width: 260px;
  height: 40px;

	outline: none;
  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
	color: ${props => props.theme.text};
  background-color: ${props => props.theme.background};

	::placeholder {
		color: ${props => props.changedColor ? props.theme.pointRed : props.theme.line};
	}

  transition: all 0.3s ease-in-out;
`;
